import * as React from "react";
import {
  IPeerGroupTabsProps,
  IVisualizationState,
  IFilter,
} from "../../lib/http";
import * as ReactHighcharts from "react-highcharts";
import PanelGraph from "app/components/tabs/PanelGraph";
const HighchartsMore = require("highcharts/highcharts-more");
HighchartsMore(ReactHighcharts.Highcharts);

export class StarRatings extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
> {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state

    const categories = ['5 Star', '4 Star', '3 Star', '2 Star', '1 Star']
    const currentPeerGroup = data.find((peerGroup) => peerGroup.filterId === filters.assetLevel)

    if (!currentPeerGroup) return;

    const title = currentPeerGroup['InvPer_T_V23_Vis23Title']

    const series = [{
      name: '1 Year',
      color: '#B4C6E7',
      data: [currentPeerGroup['InvPer_N_V23_FiveStar1Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_FourStar1Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_ThreeStar1Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_TwoStar1Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_OneStar1Yr'] * 100.0]
    },{
      name: '3 Year',
      color: '#8EA9DB',
      data: [currentPeerGroup['InvPer_N_V23_FiveStar3Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_FourStar3Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_ThreeStar3Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_TwoStar3Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_OneStar3Yr'] * 100.0]
    },{
      name: '5 Year',
      color: '#305496',
      data: [currentPeerGroup['InvPer_N_V23_FiveStar5Yr'] *100.0,currentPeerGroup['InvPer_N_V23_FourStar5Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_ThreeStar5Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_TwoStar5Yr'] * 100.0,currentPeerGroup['InvPer_N_V23_OneStar5Yr'] * 100.0]
    },];

    this.setState({ categories, series, title })
  }

  static getChartConfig(series, categories, title) {
    return {
      chart: { type: "bar", height: 500 },
      title: {
        text: title,
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
        opposite: false,
        title: "",
        labels: {
          format: "{value}%",
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: "{y:,.1f}%",
            align: 'right',
            style: {
              textOutline: false
            }
          },
        },
      },
      legend: { enabled: true },
      credits: { enabled: false },
      series,
    }
  }

  render() {
    const { title, loading, series, categories } = this.state;
    return <PanelGraph title="" loading={loading} chartConfig={StarRatings.getChartConfig(series, categories, title)} />
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Performance/StarRatings/index.tsx